import React from 'react';
import {useSelector} from 'react-redux';


import * as notificationSelectors from '../notificationSelectors';

import ToastMessage from '../ToastMessage';

import styles from './ToastMessages.scss';


function ToastMessages({}) {

    const toastMessages = useSelector(notificationSelectors.getToastMessages);

    if (toastMessages.length === 0) {

        return null;
    }

    return (
        <div className={styles.toastMessages}>
            {toastMessages.map(toastMessages => (
                <ToastMessage
                    key={toastMessages.id}
                    {...toastMessages}
                />
            ))}
        </div>
    );
}


ToastMessages.propTypes = {};

ToastMessages.defaultProps = {};


export default ToastMessages;
